import React from 'react';

export const OfficeSelect = ({ offices, value, onChange, testId, allLabel, className = '' }) => (
  <select value={value || ''} onChange={(e) => onChange(e.target.value)} data-testid={testId}
    className={`h-10 rounded-md border border-gray-300 bg-white px-3 text-sm ${className}`}>
    {allLabel && <option value="">{allLabel}</option>}
    {(offices || []).map((o) => <option key={o.id} value={o.id}>{o.name}{o.isPrimary ? ' (main)' : ''}</option>)}
  </select>
);
